import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { Observable} from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const LoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const _loaderService: LoaderService = inject(LoaderService);

  if (req.headers.getAll('background')?.find(background => background === 'true') != null) {
    return next(req.clone({
      headers: req.headers.delete('background')
    }));
  }

  _loaderService.add(req);

  return new Observable<HttpEvent<unknown>>(subscribe => {
    next(req).subscribe({
      next: response => {
        if (response instanceof HttpResponse) {
          _loaderService.delete(req);
        }
        subscribe.next(response);
      },
      error: error => {
        _loaderService.delete(req);
        subscribe.error(error);
      },
      complete: () => {
        _loaderService.delete(req);
        subscribe.complete();
      }
    });
  });
};